export default function () {
  class SortableTable {
    constructor(tableNode) {
      this.tableNode = tableNode

      this.columnHeaders = tableNode.querySelectorAll('thead th')

      this.sortColumns = []

      for (var i = 0; i < this.columnHeaders.length; i++) {
        var ch = this.columnHeaders[i]
        var buttonNode = ch.querySelector('button.sortable')
        if (buttonNode) {
          this.sortColumns.push(i)
          buttonNode.setAttribute('data-column-index', i)
          buttonNode.addEventListener('click', this.handleClick.bind(this))
        }
      }

      this.optionCheckbox = document.querySelector(
        'input[type="checkbox"][value="show-unsorted-icon"]',
      )

      if (this.optionCheckbox) {
        this.optionCheckbox.addEventListener(
          'change',
          this.handleOptionChange.bind(this),
        )
        if (this.optionCheckbox.checked) {
          this.tableNode.classList.add('show-unsorted-icon')
        }
      }
    }

    setColumnHeaderSort(columnIndex) {
      if (typeof columnIndex === 'string') {
        columnIndex = parseInt(columnIndex)
      }

      for (var i = 0; i < this.columnHeaders.length; i++) {
        var ch = this.columnHeaders[i]
        let buttonNode = ch.querySelector('button')
        let buttonType = ch.querySelector('button.sortable')
        if (i === columnIndex) {
          var value = ch.getAttribute('aria-sort')
          let typeData = buttonType.getAttribute('data-type')

          if (value === 'descending') {
            ch.setAttribute('aria-sort', 'ascending')
            this.sortColumn(
              columnIndex,
              'ascending',
              typeData
            )
          } else {
            ch.setAttribute('aria-sort', 'descending')
            this.sortColumn(
              columnIndex,
              'descending',
              typeData
            )
          }
        } else {
          if (ch.hasAttribute('aria-sort') && buttonNode) {
            ch.removeAttribute('aria-sort')
          }
        }
      }
    }

    sortColumn(columnIndex, sortValue, typeData) {
      const compareValues = (a, b) => {
        let aVal = a.value
        let bVal = b.value
      
        if (typeData == 'value') {
          if (aVal === null) aVal = ''
          if (bVal === null) bVal = ''
      
          aVal = aVal.toString().toLowerCase()
          bVal = bVal.toString().toLowerCase()
      
          if (aVal === bVal) return 0
          if (sortValue === 'ascending') return aVal < bVal ? -1 : 1
          else return aVal > bVal ? -1 : 1
        } else {
          return sortValue === 'ascending' ? aVal - bVal : bVal - aVal
        }
      }

      var tbodyNode = this.tableNode.querySelector('tbody')
      var rowNodes = []
      var dataCells = []

      var rowNode = tbodyNode.firstElementChild

      var index = 0
      while (rowNode) {
        rowNodes.push(rowNode)
        var rowCells = rowNode.querySelectorAll('th, td')
        var dataCell = rowCells[columnIndex]

        var data = {}
        data.index = index

        const dataAttr = dataCell.getAttribute('data-date')

        if (dataAttr && dataAttr.trim() !== '') {
          data.value = new Date(dataAttr.replace(' ', 'T')).getTime()
        } else {
          let value = dataCell.textContent.trim()
          if (typeData == 'num') {
            const num = parseFloat(value)
            data.value = isNaN(num) ? -Infinity : num // nombres vides = très petit
          } else if (typeData == 'date') {
            data.value = dataAttr && dataAttr.trim() !== '' ? new Date(dataAttr.replace(' ', 'T')).getTime() : -Infinity
          } else {
            data.value = value || '' // texte vide = ""
          }
        }

        dataCells.push(data)
        rowNode = rowNode.nextElementSibling
        index += 1
      }

      dataCells.sort(compareValues)

      // remove rows
      while (tbodyNode.firstChild) {
        tbodyNode.removeChild(tbodyNode.lastChild)
      }

      // add sorted rows
      for (var i = 0; i < dataCells.length; i += 1) {
        tbodyNode.appendChild(rowNodes[dataCells[i].index])
      }
    }

    /* EVENT HANDLERS */

    handleClick(event) {
      var tgt = event.currentTarget
      this.setColumnHeaderSort(tgt.getAttribute('data-column-index'))
      updateAriaLive()
    }

    handleOptionChange(event) {
      var tgt = event.currentTarget

      if (tgt.checked) {
        this.tableNode.classList.add('show-unsorted-icon')
      } else {
        this.tableNode.classList.remove('show-unsorted-icon')
      }
    }
  }

  // Initialize sortable table buttons
  window.addEventListener('load', function () {
    var sortableTables = document.querySelectorAll('.table-complex')
    for (var i = 0; i < sortableTables.length; i++) {
      let table = sortableTables[i].querySelector('table')
      let arialive = sortableTables[i].querySelector('span.arialive')
      let caption = sortableTables[i].querySelector('caption').textContent
      let buttons = table.querySelectorAll('button.sortable')

      new SortableTable(table)

      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          let ariasort = button.closest('th').getAttribute('aria-sort')
          let datasort = button.getAttribute('data-sort')
          let sort = ''
          if (ariasort == 'ascending') {
            sort = window.ICL_LANGUAGE_CODE == 'en' ? 'ascending' : ' croissant'
          } else {
            sort =
              window.ICL_LANGUAGE_CODE == 'en' ? 'descending' : 'décroissant'
          }
          updateAriaLive(arialive, caption, datasort, sort)
        })
      })
    }
  })

  function updateAriaLive(arialive, caption, datasort, sort) {
    if (!arialive) return
    if (window.ICL_LANGUAGE_CODE == 'en') {
      arialive.textContent = `The ${caption} table is now ${datasort}, ${sort}`
    } else {
      arialive.textContent = `Le tableau ${caption} est désormais ${datasort}, ${sort}`
    }
  }
}
